import { useNavigate, useLocation, NavigateOptions } from 'react-router-dom';

function useExtendedNavigation() {
    const navigate = useNavigate();
    const location = useLocation();

    /**
     * Custom navigate function that merges query params
     * @param path - The target path, can include query parameters.
     * @param options - Optional navigation options.
     */
    const extendedNavigate = (
        path: string,
        options?: NavigateOptions
    ): void => {
        // Get the current query params from the URL
        const currentSearchParams = new URLSearchParams(location.search);

        // Split the path to separate base path and new query string (if present)
        const [basePath, queryString] = path.split('?');
        if (queryString) {
            const newSearchParams = new URLSearchParams(queryString);
            // Merge new params into the current search params
            newSearchParams.forEach((value, key) => {
                currentSearchParams.set(key, value);
            });
        }

        // Construct the final path with merged query params
        const finalPath = `${basePath}?${currentSearchParams.toString()}`;
        navigate(finalPath, options);
    };

    return extendedNavigate;
}

export default useExtendedNavigation;
